import React from 'react';
import {
  ActionIcon,
  Badge,
  Checkbox,
  Menu,
  NumberFormatter,
  Skeleton
} from '@mantine/core';
import PropTypes from 'prop-types';
import { DotsVertical, ExternalLink } from 'tabler-icons-react';
import AppText from '../../common/AppText';
import AppFlexbox from '../../common/AppFlexbox';
import AppStack from '../../common/AppStack';
import AppImage from '../../common/AppImage';
import { singularPluralFormat } from '../../../helpers/format';
import AppMenu from '../../common/AppMenu';

const ExternalProductSelectItem = ({
  config,
  product,
  isAddedToVendor,
  onSelect,
  selected,
  onAction,
  disabled
}) =>
  product ? (
    <AppFlexbox
      onClick={() => {
        if (!disabled) {
          onSelect(product);
        }
      }}
      style={{
        gap: 8,
        padding: 8,
        alignItems: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer'
      }}
    >
      <AppFlexbox style={{ gap: 8, alignItems: 'center', flex: 1 }}>
        <Checkbox checked={selected} disabled={disabled} onChange={() => {}} />
        <AppFlexbox style={{ gap: 8, alignItems: 'center' }}>
          <AppStack
            style={{
              minWidth: 60,
              width: 60,
              minHeight: 60,
              height: 60,
              borderRadius: 4,
              overflow: 'hidden',
              border: 'solid 1px lightgrey'
            }}
          >
            <AppImage fit="contain" src={product.previewImage ?? ''} />
          </AppStack>

          <AppStack style={{ gap: 0 }}>
            <AppFlexbox>
              <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                {product.name}
              </AppText>
              {isAddedToVendor && <Badge color="#067D62">Imported</Badge>}
            </AppFlexbox>

            <AppText style={{ fontSize: 12, color: '#666' }}>
              {singularPluralFormat(
                product.variantCount,
                'variant',
                'variants'
              )}
            </AppText>
            <AppText style={{ fontSize: 12 }}>
              {product.minPrice === product.maxPrice ? (
                <NumberFormatter
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="$"
                  thousandSeparator
                  value={product.minPrice / 100}
                />
              ) : (
                <>
                  <NumberFormatter
                    decimalScale={2}
                    fixedDecimalScale
                    prefix="$"
                    thousandSeparator
                    value={product.minPrice / 100}
                  />{' '}
                  -{' '}
                  <NumberFormatter
                    decimalScale={2}
                    fixedDecimalScale
                    prefix="$"
                    thousandSeparator
                    value={product.maxPrice / 100}
                  />
                </>
              )}
            </AppText>
          </AppStack>
        </AppFlexbox>
      </AppFlexbox>
      {config?.products?.getProductUrlById && (
        <AppFlexbox onClick={(e) => e.stopPropagation()} style={{ gap: 8 }}>
          <AppMenu
            control={
              <ActionIcon color="dark" variant="subtle">
                <DotsVertical />
              </ActionIcon>
            }
          >
            <Menu.Item
              component="a"
              href={config.products.getProductUrlById(
                product.productExternalId
              )}
              leftSection={<ExternalLink size={18} />}
              style={{ color: '#000' }}
              target="_blank"
            >
              {config ? `View in ${config.title}` : 'View externally'}
            </Menu.Item>
          </AppMenu>
        </AppFlexbox>
      )}
    </AppFlexbox>
  ) : (
    <AppFlexbox
      style={{
        gap: 8,
        padding: 10,
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <AppFlexbox style={{ gap: 8, alignItems: 'center' }}>
        <Skeleton height={18} width={18} />
        <Skeleton height={12} width={120} />
      </AppFlexbox>
      <AppFlexbox style={{ gap: 8 }} />
    </AppFlexbox>
  );

ExternalProductSelectItem.propTypes = {
  config: PropTypes.object,
  disabled: PropTypes.bool,
  isAddedToVendor: PropTypes.bool,
  onAction: PropTypes.func,
  onSelect: PropTypes.func,
  product: PropTypes.object,
  selected: PropTypes.bool
};

export default ExternalProductSelectItem;
